// Set a cookie
function setCookie(name, value, days = 7, path = "/") {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=${path}; SameSite=Lax`;
}

// Get a cookie
function getCookie(name) {
  const encodedName = encodeURIComponent(name) + "=";
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(encodedName)) {
      return decodeURIComponent(cookie.substring(encodedName.length));
    }
  }

  return null;
}

// Delete a cookie
function deleteCookie(name, path = "/") {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; SameSite=Lax`;
}


// Code for custom featured collection starts

const AUTOPLAY_DURATION = 8000;

function initSlider() {
console.log("initSlider---");
if (!$('.owl-featured-coll').length) {
  return;
}
const $wrapper = $('.owl-featured-coll');
const $slider  = $wrapper.find('.hero-slider');

// Destroy if already initialized
if ($slider.hasClass('owl-loaded')) {
  $slider.trigger('destroy.owl.carousel');
  $slider.removeClass('owl-loaded');
}

// Remove Old custom nav
$wrapper.find('.custom-nav').remove();

// Custom nav inject
$wrapper.append(`
  <div class="custom-nav">
    <button class="custom-prev" aria-label="Previous">&#8249;</button>
    <button class="custom-next" aria-label="Next">
      <svg class="progress-ring" viewBox="0 0 50 50">
        <circle class="progress-ring__bg" cx="25" cy="25" r="21"/>
        <circle class="progress-ring__fill" cx="25" cy="25" r="21"/>
      </svg>
    </button>
  </div>
`);

const $nextBtn = $wrapper.find('.custom-next');
const fill     = $wrapper.find('.progress-ring__fill')[0];

let autoplayStopped = false;

// ── Progress helpers ──
function startProgress() {
  if (autoplayStopped || !fill) return;
  fill.classList.remove('animating');
  void fill.offsetWidth; // force reflow
  setTimeout(function () {
    fill.classList.add('animating');
  }, 50);
}

function stopProgress() {
  if (!fill) return;
  fill.classList.remove('animating');
}

// ── Permanently stop autoplay ──
function stopAutoplayPermanently() {
  if (autoplayStopped) return;
  autoplayStopped = true;
  $slider.trigger('stop.owl.autoplay');
  stopProgress();
  // Hide ring if user takes control
  $nextBtn.addClass('autoplay-stopped');
}

// ── Init Owl ──
$slider.owlCarousel({
  items: 1,
  loop: true,
  nav: false,
  dots: false,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  autoplay: true,
  autoplayTimeout: AUTOPLAY_DURATION,
  autoplayHoverPause: false,
  touchDrag: true,
  mouseDrag: true,
});

// Progress start on load
startProgress();

// Slide change pe progress restart — sirf autoplay chal rahi ho toh
$slider.on('changed.owl.carousel', function () {
  // console.log("Feat change--");
  
  setTimeout(() => {
    
    let b_id = $slider.find(".owl-item.active .hero-slide").attr("data-block-id");
    
    // console.log("b_id--",b_id);
    
    let $curr_active = $slider.parent().find(`.hover-links-wrapper li[data-block-id='${b_id}']`);
    
    // Remove "active" from all sibling <li> elements, then add it to the current one
    $curr_active.addClass("active").siblings().removeClass("active");
    
  }, 200);
    if (autoplayStopped) return;
  stopProgress();
  setTimeout(startProgress, 50);
});

// ── Swipe pe permanently stop ──
$slider.on('dragged.owl.carousel', function () {
  stopAutoplayPermanently();
});

// ── Custom next button ──
$wrapper.find('.custom-next')[0].addEventListener('pointerdown', function (e) {
  e.stopPropagation();
  stopAutoplayPermanently();
  $slider.trigger('next.owl.carousel');
}, { passive: true });

// ── Custom prev button ──
$wrapper.find('.custom-prev')[0].addEventListener('pointerdown', function (e) {
  e.stopPropagation();
  stopAutoplayPermanently();
  $slider.trigger('prev.owl.carousel');
}, { passive: true });

$(document).on('mouseover', '.owl-featured-coll .hover-links-wrapper li', function () {
  if ($(this).hasClass("no-media")) {
    return;
  }
  stopAutoplayPermanently();
  
  // Use the exact index (don't subtract 1, as Owl Carousel is 0-indexed)
  var index = $(this).index();
  console.log('index', index);
  
  // Update active class on the links immediately for snappy UI response
  // $(this).addClass('active').siblings().removeClass('active');
  
  // Trigger the carousel move
  var $carousel = $('.owl-featured-coll .owl-carousel');
  $carousel.trigger('to.owl.carousel', index);
  $carousel.find('.owl-next').removeClass("active");
});
}

document.addEventListener('DOMContentLoaded', ()=>{
setTimeout(() => {
initSlider()
}, 200);});
// Code for custom featured collection ends

document.addEventListener("DOMContentLoaded", (event) => {
  if ($("#newsletter").length > 0) {
    if (!getCookie("newsletter")) {
        setTimeout(function () {
            $("#newsletter").addClass("active");
        }, parseInt($("#newsletter").attr("data-show-after"), 10) || 0);
    }

    $("#newsletter .close-newsletter").on("click", function (e) {
        e.preventDefault();

        // Set cookie for 72000 days (same behavior as your original code)
        setCookie("newsletter", "true", 72000);

        $("#newsletter").removeClass("active");
    });
}
  if (window.location.href.includes("/collections")) {
    
    // if (!$(".owl-hero-slider").eq(0).find(".owl-item").length) {
    //   $("header").addClass("active");
    //   $("header-component").removeClass("color-scheme-6")
    //   $("header-component").addClass("color-scheme-1")
    // }
  }

$(".product-grid-container button.see-more").on('click',function(e){
  $(".product-grid-container li.product-grid__item.visually-hidden").removeClass("visually-hidden")
});

  $("#header-component cart-drawer-component[data-custom-cart]").eq(1).remove();
    console.log("dom loaded---");
    $("video > img").attr("alt","")
    setTimeout(() => {
    }, 100);


$("header-actions cart-drawer-component .header-actions__action").on("click", function (e) {
    e.stopPropagation();

    const $dialog = $("header-component cart-drawer-component dialog").eq(0);

    $dialog.attr("open") !== undefined
        ? $dialog.removeAttr("open")
        : $dialog.attr("open", "");
});

$(document).on("click", function (e) {
    const $dialog = $("header-component cart-drawer-component dialog").eq(0);

    if (
        $dialog.attr("open") !== undefined &&
        !$(e.target).closest("header-component cart-drawer-component dialog").length &&
        !$(e.target).closest("header-actions cart-drawer-component .header-actions__action").length
    ) {
        $dialog.removeAttr("open");
    }
});
$(document).on("cart:update",function (e) {
  console.log("eee---",e);
  
})
// 
if (!window.location.href.includes("/products")) {
  

document.querySelectorAll('slideshow-component').forEach(slider => {

  const track =
    slider.querySelector('.slider__slides') ||
    slider.querySelector('slideshow-slides');

  if (!track) return;

  const slides = track.children;
  if (!slides.length) return;

  const slideWidth = slides[0].getBoundingClientRect().width;

  const prev = slider.querySelector(
    'button[ref="previous"], .slider-button--prev, .slideshow__control--prev'
  );

  const next = slider.querySelector(
    'button[ref="next"], .slider-button--next, .slideshow__control--next'
  );

  function updateButtons() {
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
  }

  function scrollNext() {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const newPos = Math.min(track.scrollLeft + slideWidth, maxScroll);

    track.scrollTo({
      left: newPos,
      behavior: "smooth"
    });
  }

  function scrollPrev() {
    const newPos = Math.max(track.scrollLeft - slideWidth, 0);

    track.scrollTo({
      left: newPos,
      behavior: "smooth"
    });
  }

  if (prev) {
    prev.addEventListener("click", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollPrev();
    });
  }

  if (next) {
    next.addEventListener("click", e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollNext();
    });
  }

  // update buttons on scroll
  track.addEventListener("scroll", updateButtons);

  // initial state
  // updateButtons();

});
}
// 


    $(document).on("click", ".continue-shopping span", function () {
	  $("cart-icon").trigger("click")
	});

  $(".open-search").click(function () {
		if($("#instant-search").hasClass("active")) {
			$("#instant-search").removeClass("active");
		} else {
			$("#instant-search").addClass("active");
		}
		return false;
	});
  $(".close-search").click(function () {
    $("#instant-search").removeClass("active")
  })
// 
function toggleScrollTopClass() {
    document.body.classList.toggle('scroll-top', window.scrollY <= 70);
}

window.addEventListener('scroll', toggleScrollTopClass);
toggleScrollTopClass(); // Run on page load
// 

$(document).on('mouseenter', '.mega-menu__link', function () {
  const menuGridId = $(this).closest('[data-menu-grid-id]').data('menu-grid-id');
  const index = $(this).data('index');

  if (!menuGridId || !index) return;

  const $container = $(`[data-menu-grid-id="${menuGridId}"]`);

  const $target = $container.find(
    `.custom-featured-image[data-index="${index}"]`
  );

  // Already active? Do nothing
  if ($target.hasClass('active')) return;

  $container
 .find('.custom-featured-image.active .text-block')
 .hide();
 
  $container
    .find('.custom-featured-image.active')
    .stop(true, true)
    .removeClass('active')
    .fadeOut();


    $target
    .find('.group-block-content')
    .fadeIn();

  $target
    .stop(true, true)
    .addClass('active')
    .hide()
    .fadeIn();
    
});

let lastScrollTop = 0;
const delta = 5;

$(window).on("resize scroll load", function() {
  const currentScroll = window.scrollY;

  if (Math.abs(currentScroll - lastScrollTop) < delta) return;

  document.querySelectorAll('header').forEach(el => {
    el.classList.toggle('scroll-down', currentScroll > lastScrollTop);
    el.classList.toggle('scroll-up', currentScroll < lastScrollTop);
    
    if (window.location.href.includes("/collections")) {
      
      if (el.classList.contains("scroll-up") && el.classList.contains("active")) {
        el.querySelector("header-component").classList.remove("color-scheme-6")
        el.querySelector("header-component").classList.add("color-scheme-1")
         
      }
      else{
        el.querySelector("header-component").classList.remove("color-scheme-1")
        el.querySelector("header-component").classList.add("color-scheme-6")
      }
    }

  });

  lastScrollTop = currentScroll;
});
$(window).on("resize scroll load", function() {
	if($(window).scrollTop() > 20) {
		$("header").addClass("active");
	} else {
		$("header").removeClass("active");
    if (window.location.href.includes("/collections/")) {
      if (!$(".owl-hero-slider").eq(0).find(".owl-item").length) {
      $("header").addClass("active");
    }
    }
	}
	if($(window).scrollTop() > 200) {
		$("header").removeClass("nav-fix");
	} else {
		$("header").addClass("nav-fix");
	}
});
// 
function removeDuplicateCartDrawer() {
    const $cartDrawers = $("#header-component cart-drawer-component[data-custom-cart]");

    if ($cartDrawers.length > 1) {
        $cartDrawers.slice(1).remove();
    }
}

removeDuplicateCartDrawer();

const observer = new MutationObserver(removeDuplicateCartDrawer);
observer.observe(document.body, {
    childList: true,
    subtree: true
});
// const AUTOPLAY_DURATION = 8000;
// let should_autoPlay=true

// $('.slideshow-section').each(function () {
//   const $section = $(this);
//   $section
//     .find('slideshow-slide')
//     .hide()
//     .removeClass('custom-active')
//     .first()
//     .show()
//     .addClass('custom-active');

//   startAutoplay($section);
// });

// function startProgress($section) {
//   const fill = $section.find('.progress-ring__fill')[0];
//   if (!fill) return;

//   fill.classList.remove('animate');
  
//   setTimeout(function () {
//     fill.classList.add('animate');
//   }, 50); // small delay forces browser to repaint first
// }

// function changeSlide($section, direction = 'next') {
//   const $slides = $section.find('slideshow-slide');
//   const $current = $slides.filter('.custom-active');

//   let currentIndex = $slides.index($current);
//   if (currentIndex === -1) currentIndex = 0;

//   const nextIndex =
//     direction === 'next'
//       ? (currentIndex + 1) % $slides.length
//       : (currentIndex - 1 + $slides.length) % $slides.length;

//   $current.stop(true, true).removeClass('custom-active').fadeOut(1500);
//   $slides.eq(nextIndex).stop(true, true).hide().addClass('custom-active').fadeIn(1500);
//   // console.log("currentIndex",currentIndex);
//   // console.log("nextIndex",nextIndex);
  

//   // ❌ startProgress yahan se hata diya
// }

// function startAutoplay($section) {
//   // if (should_autoPlay==false) return;
//   if ($section.data('autoplay-timer')) {
//     clearInterval($section.data('autoplay-timer'));
//   }
//   if ($section.find('slideshow-slide').length <= 1) return;

//   // ✅ Pehle progress start karo
//   startProgress($section);

//   const timer = setInterval(function () {
//     changeSlide($section, 'next');
//     // ✅ Har slide change ke baad progress restart
//     startProgress($section);
//   }, AUTOPLAY_DURATION);
  
//   if (should_autoPlay==false) clearInterval(timer);
//   if (should_autoPlay==false) $(".progress-ring__fill").css("stroke-width",0);
// console.log("should_autoPlay",should_autoPlay);

//   $section.data('autoplay-timer', timer);
// }

// function stopAutoplay($section) {
//   if ($section.data('autoplay-timer')) {
//     clearInterval($section.data('autoplay-timer'));
//     $section.data('autoplay-timer', null);
//   }
//   const fill = $section.find('.progress-ring__fill')[0];
//   if (fill) fill.classList.remove('animate');
// }

// $(document).on('click', '.slideshow-section .next', function () {
//   const $section = $(this).closest('.slideshow-section');
//   stopAutoplay($section);
//   changeSlide($section, 'next');
//       should_autoPlay=false;
//   startAutoplay($section);
// });

// $(document).on('click', '.slideshow-section .prev', function () {
//   const $section = $(this).closest('.slideshow-section');
//   stopAutoplay($section);
//   changeSlide($section, 'prev');
//       should_autoPlay=false;
//   startAutoplay($section);
// });


// function initSwipeSupport($section) {
//   let startX = 0;
//   let startY = 0;
//   let isDragging = false;
//   console.log("isDragging",isDragging);
  

//   const element = $section[0];
//   if (!element) return;

//   element.addEventListener('pointerup', function (e) {
//     // Sirf touch/pen — mouse nahi
//     console.log("pointerup",isDragging);
//     if (e.pointerType === 'mouse') return;
//     startX = e.clientX;
//     startY = e.clientY;
//     isDragging = true;
//     element.setPointerCapture(e.pointerId);
//      const swipeX = e.clientX - startX;
//     const swipeY = e.clientY - startY;
// console.log("swipeX",swipeX);
//     console.log("isDragging",isDragging);
    
//   }, { passive: true });

//   element.addEventListener('pointerdown', function (e) {
//     // if (!isDragging || e.pointerType === 'mouse') return;
//     isDragging = false;
//     console.log("pointerup",isDragging);
//     should_autoPlay=false;
//    startAutoplay($(".slideshow-section")) 
//     const swipeX = e.clientX - startX;
//     const swipeY = e.clientY - startY;
// console.log("swipeX",swipeX);
// console.log("swipeY",swipeY);

//     // Vertical scroll ignore
//     if (Math.abs(swipeY) > Math.abs(swipeX)) return;

//     // Minimum distance check
//     if (Math.abs(swipeX) < 50) return;

//     stopAutoplay($section);
//     // console.log("swipeX--",swipeX);
    
//     swipeX < 0
//       ? changeSlide($section, 'next')
//       : changeSlide($section, 'prev');
//     startAutoplay($section);

//   }, { passive: true });

//   element.addEventListener('pointercancel', function () {
//     isDragging = false;
//   }, { passive: true });
// }
// initSwipeSupport($(".slideshow-section slideshow-component"))

 });

// Code for custom variant dropdown starts
// Select option
$(document).on("click", ".accordion-custom .cstm-option", function () {
    let $accordion = $(this).closest(".accordion-custom");
    let option = $accordion.attr("data-option-id");
    let opt_id = $(this).attr("data-option-value-id");

    let $select = $("#" + option);

    if (!$select.length) {
        console.warn("No select found for ID:", option);
        return;
    }

    let $targetOption = $select.find(
        `option[data-option-value-id="${opt_id}"]`
    );

    if (!$targetOption.length) {
        console.warn("No matching option found for opt_id:", opt_id);
        return;
    }

    $select.val($targetOption.val());
    $select[0].dispatchEvent(new Event("change", { bubbles: true }));

    // Update accordion title
    $accordion.find(".details__header").contents().first()[0].textContent =
        $(this).text().trim();

    // Close accordion
    // $accordion.find(".details-content").slideUp(100);
    $accordion.find(".details-content").hide()
    $accordion.removeClass("active");
});


// Toggle accordion
$(document).on("click", ".accordion-custom .details__header", function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $accordion = $(this).closest(".accordion-custom");
    let $content = $accordion.find(".details-content");

    if ($accordion.hasClass("active")) {
        // $content.slideUp(100);
        $content.hide();
        $accordion.removeClass("active");
    } else {
        $(".accordion-custom.active")
            .removeClass("active")
            .find(".details-content")
            .hide();

        $accordion.addClass("active");
        $content.show();
        // $content.slideDown(100);
    }
});


// Close when clicking outside
$(document).on("click", function (e) {
    if (!$(e.target).closest(".accordion-custom").length) {
        $(".accordion-custom.active")
            .removeClass("active")
            .find(".details-content")
            .hide();
    }
});
// Code for custom variant dropdown ends


//  
$(document).on("click", ".may-we-suggest__add-to-cart", function () {
		var variantId = $(".may-we-suggest-product option:selected").attr("data-variant-id");
    console.log("ggg",{ id: variantId, quantity: 1 });
    
   	$.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: { id: variantId, quantity: 1 },
      success: function(product) { 
        const $dialog = $(".dialog-drawer.cart-drawer__dialog[open]");

$.get(location.href, function (html) {
    const newContent = $(html)
        .find(".dialog-drawer.cart-drawer__dialog")
        .html();
// Update cart count bubble
    const cartCount = $(html)
        .find("cart-drawer-component cart-icon")
        .html();
console.log("icon",$("cart-drawer-component cart-icon"));
    $dialog.html(newContent);
      $("cart-drawer-component cart-icon").html(cartCount);
});
      },
      error: function (err) {
          console.log("err00",err.responseJSON.message)
          alert("Error- "+err.responseJSON.message)
      }
    });
	});
$("body").on("change", ".may-we-suggest-product", function () {
		$(".may-we-suggest__price").html($(".may-we-suggest-product option:selected").attr("data-price"));
});

if (window.location.href.includes("/products")) {
  $(".model-3d").on("click", function () {
    $(".model-3d-section iframe").first()[0].scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
  //  $('html,body').animate({
  //     scrollTop: $(".model-3d-section iframe").offset().top},
  // 'linear');
});
  
}
// $(".pdp-accodion-card accordion-custom ").eq(0).find(".details-content").show()
$(".pdp-accodion-card accordion-custom").on("click", function () {
  // $(".pdp-accodion-card accordion-custom .details-content")
  //       .not($(this).find(".details-content"))
  //       .slideUp();
        $(this).find(".details-content").stop(true, true).slideDown();
        $(".pdp-accodion-card accordion-custom details[open] .details-content")
            .not($(this).find("details[open] .details-content")).stop(true, true).slideUp();
        $(".pdp-accodion-card accordion-custom details")
            .not($(this).find("details"))
            .removeAttr("open");
  setTimeout(() => {
  }, 50);
});

$(document).on('click', function (e) {
    const $details = $('.accordian-filter-wrapper #Details-filter-options');

    if (
        $details.is('[open]') &&
        !$(e.target).closest('.accordian-filter-wrapper #Details-filter-options').length
    ) {
        $details.removeAttr('open');
    }
});
// 

//  Animation on Scroll js starts
document.addEventListener("DOMContentLoaded", () => {
    
    const revealElements = document.querySelectorAll(".scroll-reveal");

const observerOptions = {
    root: null,
    rootMargin: "-10px",
    threshold: 0.15
};

const observerCallback = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add("active");
        } else {
            // Only remove "active" if the element is BELOW the viewport (not yet scrolled to)
            // If it's above the viewport (already passed), keep it active
            if (entry.boundingClientRect.top > 0) {
                entry.target.classList.remove("active");
            }
        }
    });
};

const observer = new IntersectionObserver(observerCallback, observerOptions);

revealElements.forEach(element => {
    observer.observe(element);
});
});

//  Animation on Scroll js ends
// start Header js for color
(function ($) {
  var $header = $('#header-component');
  var $slider = $('.hero-slider');

  function updateHeaderClass() {
    var $content = $slider.find('.owl-item.active:not(.cloned) .hero-content').first();
    if (!$content.length) {
      $content = $slider.find('.owl-item.active .hero-content').first();
    }
    if (!$content.length) return;

    var isWhite = $content.hasClass('text-color-white');
    $header.toggleClass('collection-header-inverse', isWhite);
  }

  updateHeaderClass();

  $slider.on('changed.owl.carousel translated.owl.carousel', function () {
    setTimeout(updateHeaderClass, 50);
  });

  new MutationObserver(updateHeaderClass).observe($slider[0], {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})(jQuery);